import { useEffect, useState } from "react";
import { useAuthStore, User } from "src/components/main/authStore";
import { numberReducer, MyDate, officeHolidays } from "src/components/common/functions";
import { Form, useRouteLoaderData, Link } from "react-router-dom";
import { Data, TimeOff, timeOffsTypes } from "./types";
import { AsyncFormSelect } from "../forms/records/form/AsyncFormSelect";
import { SelectOption } from "../forms/types";
export default function TimeOffForm({
    keyword
}:{
    keyword: "Add" | "Edit"
}){
        const curUser = useAuthStore(state => state.user) as User;
    const [timeOff, setTimeOff] = useState(useRouteLoaderData("TimeOff")?.timeOff ?? {
        requester: {
            label: curUser.userName,
            value: curUser.id,
            department: curUser.department, 
            outside: curUser.outside, 
            projects: curUser.projects
        },
        approver: null, 
        data: [], 
        notes: "", 
        pdfId: "", 
        type: "", 
        fromDate: "", 
        toDate: "",  
        id: "", 
        createdAt: ""
    });
    const getDates = (startDate: MyDate, stopDate: MyDate) => {
        const dateArray = [];
        let currentDate = startDate;
        while(currentDate <= stopDate){
            const dateString = currentDate.s();
            const obj = {date: dateString, hours: "8", startTime: "", weekend: false, holiday: false, disabled: false, holidayName: ""};
            if(currentDate.getDay() === 6 || currentDate.getDay() === 0){
                obj.hours = "0"; 
                obj.weekend = true;
                obj.disabled = true;
            }
            const isHoliday = officeHolidays(Number(dateString.split("-")[0])).find(h => h.date === dateString);
            if(isHoliday){
                obj.hours = "0"; 
                obj.holiday = true;
                obj.holidayName = isHoliday.name;
                obj.disabled = true;
            }
            dateArray.push(obj);
            currentDate = new MyDate(currentDate.setDate(currentDate.getDate() + 1));
        }
        return dateArray;
    }
    const totalHours = timeOff.data.map((v: Data) => window.Number.parseFloat(v.hours || "0")).reduce(numberReducer, 0);
    useEffect(() => {
    setTimeOff((prev:TimeOff) => ({
        ...prev,
        data: getDates(
            new MyDate(prev.fromDate.replace(/-/g, "/")), 
            new MyDate(prev.toDate.replace(/-/g, "/"))
        )
    }));
    }, [timeOff.fromDate, timeOff.toDate]);
    return(
        <Form
            method = "post" 
            className = "my-3" 
        >
            {keyword === "Edit"?
            <input
                type = "hidden"
                name = "id" value = {timeOff.id}
            />
            :null}
            <input
                type = "hidden"
                name = "action" value = {keyword}
            />
            <input
                type = "hidden"
                name = "data" value = {JSON.stringify(timeOff.data)}
            />
            <input
                type = "hidden"
                name = "totalHours" value = {JSON.stringify(totalHours)}
            />
            <ul>
                <li>
                    You must submit requests for absences, other than sick leave, two weeks prior to the first day you will be absent. 
                </li>
            </ul>
            <div className = "blk5 align-items-center mb-2">
                <div className = "fw-bold me-3 mb-2 required-field">Request Date:</div>
                <div className = "d-flex align-items-center mb-2 me-3">
                    <label className = "me-2" htmlFor = "fromDate">From</label>
                    <input
                        required
                        type = "date"
                        min = "1900-01-01"
                        max = {timeOff.toDate || "2999-12-31"}
                        className = "form-control"
                        id = "fromDate"
                        name = "fromDate"
                        value = {timeOff.fromDate}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            const next = {...timeOff};
                            next.fromDate = value;
                            setTimeOff(next);
                        }}
                    />
                </div>
                <div className = "blk5 align-items-center mb-2">
                    <label className = "me-2" htmlFor = "toDate">To</label>
                    <input
                        required
                        type = "date"
                        min = {timeOff.fromDate || "1900-01-01"}
                        max = "2999-12-31"
                        className = "form-control"
                        name = "toDate"
                        id = "toDate"
                        value = {timeOff.toDate}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            const next = {...timeOff};
                            next.toDate = value;
                            setTimeOff(next);
                        }}
                    />
                </div>
            </div>
            {timeOff.fromDate && timeOff.toDate && timeOff.requester.outside === "no"?<>
            <span><strong>Detail Hours:</strong></span>
            <span className  = "ms-3">(2-hour increment)</span>
            <ul>
                {timeOff.data.map((v: Data, i: number) => <li key = {i} className = "my-3">
                    <span className = "me-2">{v.date}</span>
                    {v.holiday || v.weekend?null:<>
                    <span className = "blk3">
                        {Number(v.hours) < 8?
                        <>
                        <span className = "me-2">start from</span>
                        <input
                            type = "time"
                            min = "06:00"
                            max = "16:00"
                            name = {"startTime" + i}
                            required
                            className = "form-control inline me-2"
                            value = {v.startTime}
                            onChange = {e => {
                                const next = {...timeOff};
                                timeOff.data[i].startTime = e.currentTarget.value;
                                setTimeOff(next);
                            }}
                        />
                        </>:<></>}
                        <input
                            className = "form-control inline me-2"
                            style = {{textAlign: "center"}}
                            required
                            disabled = {timeOff.requester.outside !== "no"}
                            type = "number"
                            step = {2}
                            max = {8}
                            min = {0}
                            name = {"hours" + i}
                            value = {v.hours}
                            onChange = {e => {
                                const next = {...timeOff};
                                timeOff.data[i].hours = e.currentTarget.value;
                                setTimeOff(next);
                            }}
                        />
                        <span className = "me-2">hours</span>
                    </span>
                    </>}
                    {v.holiday?<span className = "me-2 text-info">({v.holidayName})</span>:null}
                    {v.weekend?<span className = "me-2 text-success">(weekend)</span>:null}
                </li>)}
            </ul>
            {timeOff.data.length?
            <div className = "fw-bold">
                Total: <span style = {{color: "green"}}>{totalHours} hours</span>
            </div>
            :null}
            </>:null}
            <div className = "blk5 mb-2 d-flex align-items-center">
                <label className = "fw-bold me-3 required-field text-nowrap" htmlFor = "type">Type of Absence Requested:</label>
                <select
                    className = "form-control w-auto"
                    required
                    name = "type"
                    id = "type"
                    value = {timeOff.type}
                    onChange = {e => setTimeOff({...timeOff, type: e.currentTarget.value})}
                >
                    <option value = "">Select</option>
                    {timeOffsTypes.map((type, typei) => <option key = {typei}>{type}</option>)}
                    {timeOff.requester.projects !== "no"?<option>Time Off Without Pay</option>:null}
                </select>
            </div>
            {curUser.projects !== "no"?<>
            <div className = "blk5 mb-2 d-flex align-items-center">
                <label children = "Requester" className = "fw-bold me-3 required-field" htmlFor = "requesterId"/>
                <div style = {{minWidth: 200, flexGrow: 1}}>
                    <AsyncFormSelect
                        placeholder = "Search user…"
                        required = {true}
                        name = "requesterId"
                        inputId = "requesterId"
                        fileName = "common/searchUser.php"
                        value = {timeOff.requester}
                        onChange = {next => setTimeOff({...timeOff, requester: next as SelectOption})}
                    />
                </div>
            </div>
            </>:
            <div className = "blk5 mb-2 d-flex align-items-center">
                <label children = "Requester" className = "fw-bold me-3 required-field" htmlFor = "requesterId"/>
                <div style = {{minWidth: 200, flexGrow: 1}}>
                    <span
                        children = {curUser.userName}
                    />
                    <input type = "hidden" name = "requesterId" value = {curUser.id}/>
                </div>
            </div>
            }
            <div className = "blk5 mb-2 d-flex align-items-center">
                <label children = "Department" className = "fw-bold me-3 required-field text-nowrap" htmlFor = "department"/>
                <input
                    className = "form-control"
                    disabled
                    id = "department"
                    name = "department"
                    value = {timeOff.requester.department ?? ""}
                />
            </div>
            <div className = "blk5 mb-2 d-flex align-items-center">
                <label children = "Approver" className = "fw-bold me-3 required-field" htmlFor = "approverId"/>
                <div style = {{minWidth: 200, flexGrow: 1}}>
                        <AsyncFormSelect
                            placeholder = "Search user…"
                            required = {true}
                            name = "approverId"
                            inputId = "approverId"
                            fileName = "timeOffs/searchApprover.php"
                            value = {timeOff.approver}
                            onChange = {(next) => setTimeOff({...timeOff, approver: next as SelectOption})}
                        />
                </div>
            </div>
            <label children = "Notes" className = "mb-2 fw-bold" htmlFor = "notes"/>
            <textarea
                id = "notes"
                name = "notes"
                defaultValue = {timeOff.notes ?? ""}
                className = "form-control mb-2"
                style = {{width: "100%"}}
            />
            <div>
                <button
                    children = {keyword}
                    className = "btn btn-primary me-3"
                />
                <Link children = "Back" to = ".." className = "btn btn-outline-secondary float-end"/>
            </div>
        </Form>
    )
}